/**
 * Value used to indicate a group of locales; those that are any Stripe
 * supported localisation.
 */
export const ANY_SUPPORTED_LOCALE = 'ANY_SUPPORTED_LOCALE';

/**
 * Tests a single available locale against a candidate locale.
 * @param available The available locale. The const `ANY_SUPPORTED_LOCALE` acts
 *                  as a wildcard and assumes the candidate locale has already
 *                  been sanitized and is one of our supported locales.
 * @param candidate The candidate locale.
 * @returns null if candidate does not match available, otherwise the longest
 *          matching tag between available and candidate.
 * @example
 * // returns 'en'
 * matchLocale('en-US', 'en-GB');
 * @example
 * // returns 'en-US'
 * matchLocale(ANY_SUPPORTED_LOCALE, 'en-US');
 * @example
 * // returns null
 * matchLocale('en-US', 'fr-FR');
 */
export const matchLocale = (
  available: string,
  candidate: string,
): string | null => {
  if (available === ANY_SUPPORTED_LOCALE) {
    return candidate;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const matchedParts: Array<any | string> = [];
  const availableParts = available.split('-');
  const candidateParts = candidate.split('-');

  availableParts.every((part, i) => {
    if (part !== candidateParts[i]) {
      return false;
    }
    matchedParts.push(part);
    return true;
  });

  return matchedParts.length > 0 ? matchedParts.join('-') : null;
};
